import useJwt from '@/auth/jwt/useJwt'
import moment from 'moment';
import store from '@/store/index';

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  const userData = getUserData();
  if (!userData) {
    return false;
  }
  const isExpired = isTokenExpired(userData);
  if (isExpired) {
    logout();
    return false;
  }

  return !!localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
}

export const getUserData = () => store.state.userData.userData;

export const isTokenExpired = () => {
  const expireAt = localStorage.getItem(useJwt.jwtConfig.storageExpireAtKeyName);
  if (!expireAt) {
    return true;
  }

  const local = moment(expireAt);
  const diff = local.diff(moment(), 'minutes');

  return diff <= 0;
}

export const logout = () => {
  localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
  localStorage.removeItem(useJwt.jwtConfig.storageExpireAtKeyName)
  localStorage.removeItem('currentApp')
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  console.log("role", userRole)
  // if (userRole === 'admin') return '/'
  // if (userRole === 'client') return { name: 'access-control' }
  // return { name: 'auth-login' }
  return '/'
}

const permissionsPerPage = {
  users: {
    rule: 'equal',
    permissions: ['users'],
  },
  editConf: {
    rule: 'contains',
    permissions: ['config.'],
  },
  config: {
    rule: 'equal',
    permissions: ['config.applications'],
  },
  defaultConf: {
    rule: 'equal',
    permissions: ['config.default'],
  },
  config: {
    rule: 'equal',
    permissions: ['config.layers'],
  },
}